/**
 * Get customer LTV with term multiplier used in calculation
 * LTV = life-time value
 *
 * @param {Object} order - (see below)
 * 		@param {Number} total - order.total (in cents)
 * 		@param {Array} subscriptions - Array of subscription objects
 * @return {Array} [ltv, termMultiplier]
 */
export const getLTV = ({ subscriptions, total }) => {
	const termMultiplier = getTermMultiplier({ subscriptions });
	const ltv = total * termMultiplier;
	return [ltv, termMultiplier];
};

/**
 * Get multiplier for a given sub terms for LTV calculations
 * LTV calculations from Dan; https://github.com/cratejoy/marketplace/issues/6921
 *
 * @param {Object} order
 * 		@param {Bool} autorenew - is order autorenewing
 * 		@param {Array} subscriptions - Array of subscription objects
 * @return {Number} multiplier for a given sub terms
 */
export const getTermMultiplier = ({ autorenew, subscriptions }) => {
	const renews = autorenew || subscriptions.some(s => s.autorenew);
	if (!renews) {
		return 1;
	}

	const sub = subscriptions && subscriptions[0];
	const isMonthly = sub && (sub.billing.rebillMonths === 1);
	if (!isMonthly) {
		return 2;
	}

	switch (sub.term.numCycles) {
		case 1:
			return 4.1;
		case 3:
			return 2.3;
		case 6:
		case 12:
			return 1.5;
		default:
			return 2;
	}
};

export default getLTV;
